// Helper to get config from localStorage first, then fall back to process.env
const getFromLocalStorage = (key: string): string | null => {
  if (typeof window !== 'undefined' && window.localStorage) {
    return localStorage.getItem(key);
  }
  return null;
};

export const RUNTIME_ENV =
  getFromLocalStorage('RUNTIME_ENV') || process.env.RUNTIME_ENV || 'production';
export const OPAL_BACKEND_URL =
  getFromLocalStorage('OPAL_BACKEND_URL') ||
  process.env.OPAL_BACKEND_URL ||
  'https://opal-backend.optimizely.com';

export const OPAL_URL =
  getFromLocalStorage('OPAL_URL') || process.env.OPAL_URL || 'https://opal.optimizely.com';
export const OKTA_LOGOUT_URL = `${OPAL_URL}/logout`;
export const HYPATIA_URL =
  getFromLocalStorage('HYPATIA_URL') ||
  process.env.HYPATIA_URL ||
  'https://opal.optimizely.com/hypatia';
export const INSTRUCTIONS_URL = `${OPAL_URL}/instructions-service`;
export const SEGMENT_WRITE_KEY =
  getFromLocalStorage('SEGMENT_WRITE_KEY') || process.env.SEGMENT_WRITE_KEY || '';
// Fullstory org id is environment-specific (separate org per localdev/integration/
// production) so each environment records to its own Fullstory org. An empty value
// is a no-op: Fullstory is never initialized, which keeps the app safe before keys
// are provisioned and keeps localdev off by default.
export const FULLSTORY_ORG_ID =
  getFromLocalStorage('FULLSTORY_ORG_ID') || process.env.FULLSTORY_ORG_ID || '';
export const OPTIMIZELY_SDK_KEY =
  getFromLocalStorage('OPTIMIZELY_SDK_KEY') || process.env.OPTIMIZELY_SDK_KEY || '';
export const OPAL_SYSTEM_INSTRUCTION_MANAGER_FEATURE_FLAG = 'system_instructions';
export const HOME_URL =
  RUNTIME_ENV === 'production' ? 'https://home.optimizely.com' : 'https://prep.home.optimizely.com';
export const EMAIL_DOMAIN_SUFFIX_US = '.opal.optimizely.com';
export const EMAIL_DOMAIN_SUFFIX_EU = '.eu.opal.optimizely.com';

export const EMAIL_DOMAIN_SUFFIX =
  getFromLocalStorage('EMAIL_DOMAIN_SUFFIX') ||
  process.env.EMAIL_DOMAIN_SUFFIX ||
  EMAIL_DOMAIN_SUFFIX_US;

export const getEmailDomainSuffix = (hostedRegion?: string): string => {
  return hostedRegion === 'EU' ? EMAIL_DOMAIN_SUFFIX_EU : EMAIL_DOMAIN_SUFFIX_US;
};
export const WS_GATEWAY_URL = process.env.WS_GATEWAY_URL || 'https://ws.opal.optimizely.com';
export const SOCKETIO_PATH = '/opal-socket/opal-app-socket.io';
export const MCP_MANAGER_URL =
  getFromLocalStorage('MCP_MANAGER_URL') ||
  process.env.MCP_MANAGER_URL ||
  `${OPAL_URL}/mcp-manager`;
export const MCP_DOMAIN =
  getFromLocalStorage('MCP_DOMAIN') || process.env.MCP_DOMAIN || 'mcp.opal.optimizely.com';
export const SYNAPSE_URL = getFromLocalStorage('SYNAPSE_URL') || `${OPAL_URL}/synapse`;
export const ODP_BASE_URL =
  getFromLocalStorage('ODP_BASE_URL') || process.env.ODP_BASE_URL || 'https://app.zaius.com';
export const CMP_BASE_URL =
  getFromLocalStorage('CMP_BASE_URL') ||
  process.env.CMP_BASE_URL ||
  (RUNTIME_ENV === 'production'
    ? 'https://cmp.optimizely.com/'
    : 'https://cmp-dev.optimizely.com/');
